import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { MAINTENANCE_CHECKLIST_PATH } from '../../../../config/paths';
import {
  clearMaintenanceChecklist,
  getMaintenanceChecklist,
} from '../../../../actions/mechanical-maintenance';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import MaintenanceChecklistBasicInformationResource from './resource/MaintenanceChecklistBasicInformationResource';
import MaintenanceChecklistActivityInformationResource from './resource/MaintenanceChecklistActivityInformationResource';
import MaintenanceChecklistToolbar from './MaintenanceChecklistToolbar';

export const MaintenanceChecklist = ({
  breadcrumbs,
  dispatchGetMaintenanceChecklist,
  dispatchClearMaintenanceChecklist,
  match: {
    params: { id: maintenanceChecklistId },
  },
  loading,
  maintenanceChecklist,
}) => {
  useLayoutEffect(() => {
    dispatchGetMaintenanceChecklist({ maintenanceChecklistId });

    return () => dispatchClearMaintenanceChecklist();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (maintenanceChecklist.isEmpty())
    content = <NoDataResource returnPage={MAINTENANCE_CHECKLIST_PATH} />;
  else {
    const maintenanceChecklistJson = maintenanceChecklist.toJS();

    content = (
      <>
        <h3>Información Básica</h3>
        <MaintenanceChecklistBasicInformationResource
          {...maintenanceChecklistJson}
        />

        <div className="mb-3">
          <h3>Actividades Cargadas</h3>
          <MaintenanceChecklistActivityInformationResource
            {...maintenanceChecklistJson}
          />
        </div>
      </>
    );

    toolbar = (
      <MaintenanceChecklistToolbar
        serviceOrderId={maintenanceChecklistJson.serviceOrderId}
        serviceOrderStatus={maintenanceChecklistJson.serviceOrderStatus}
        maintenanceChecklist={maintenanceChecklistJson}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Recepción de Mantenimiento"
      content={content}
      toolbar={toolbar}
    />
  );
};

MaintenanceChecklist.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearMaintenanceChecklist: PropTypes.func.isRequired,
  dispatchGetMaintenanceChecklist: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  maintenanceChecklist: PropTypes.instanceOf(Immutable.Map).isRequired,
};

MaintenanceChecklist.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearMaintenanceChecklist: clearMaintenanceChecklist,
  dispatchGetMaintenanceChecklist: getMaintenanceChecklist,
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  breadcrumbs: [
    ...MechanicalMaintenanceUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Recepciones de Mantenimiento',
      href: MAINTENANCE_CHECKLIST_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  maintenanceChecklist: MechanicalMaintenanceUnit.MaintenanceChecklist.getIn([
    'current',
    'content',
  ]),
  loading: !MechanicalMaintenanceUnit.MaintenanceChecklist.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MaintenanceChecklist);
